import { Outlet } from 'react-router-dom'

import { PageArea } from '../page-area/PageArea'
import { DesktopGrid, PageContainer, PageContent, SafeAreaTop } from './PageLayout.styled'

import type { ReactNode } from 'react'
import type { PageLayoutProps } from './PageLayout.types'

type Props = PageLayoutProps & {
  showNavigation: boolean
  mandateBanner: ReactNode
  environmentBanner: ReactNode
  safeAreaColor: string
}

export const DesktopPageLayout = ({
  header,
  navigation,
  children,
  showNavigation,
  mandateBanner,
  environmentBanner,
  safeAreaColor,
}: Props) => {
  return (
    <PageContainer>
      <DesktopGrid showNavigation={showNavigation}>
        <>
          {showNavigation ? (
            <PageArea gridArea='navigation' style={{ zIndex: 1, minWidth: 0 }}>
              {navigation}
            </PageArea>
          ) : null}
          <SafeAreaTop $bgColor={safeAreaColor} />
          <PageArea gridArea='banner'>
            {environmentBanner}
            {mandateBanner}
          </PageArea>
          <PageArea gridArea='header'>{header ?? header}</PageArea>
          <PageContent>{children || <Outlet />}</PageContent>
        </>
      </DesktopGrid>
    </PageContainer>
  )
}
